import React from 'react';
import Page from 'src/components/Page';
import { Container, Grid, Hidden } from '@material-ui/core';
import SimpleItems from './VariableEditItems';
import PaymentsTab from 'src/components/PaymentsTab';
import { useLocation } from 'react-router-dom';

const Variable = () => {
  const location = useLocation();
  const data = location.state.data;
  return (
    <Page title="Edit Variable Link">
      <Container maxWidth={false}>
        <Grid container>
          <Hidden mdDown>
            <Grid item xs={12} sm={12} lg={3} xl={2}>
              <PaymentsTab val="links" />
            </Grid>
          </Hidden>
          <Grid
            item
            xs={12}
            sm={12}
            lg={9}
            xl={10}
            style={{
              borderRight: '1px solid #eaeaea6e'
            }}
          >
            <SimpleItems data={data} />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default Variable;
